import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreferencesFacade } from '../../../facades/preferences.facade';
import { RATING_AGENCIES } from './../../../helpers/issue/ratings';

@Component({
  styleUrls: ['./ratings.component.scss'],
  template: `
    <div class="c-d-flex ratings" *ngIf="params?.data">
      <muni-shared-brief-agency-rating
        *ngFor="let agency of agencies"
        [height]="24"
        [deal]="params.data"
        [agencyName]="agency.name"
        [isUnderlyingViewOn]="isUnderlyingViewOn$ | async"
        [automationPrefix]="'deal-' + params.data.id"
      >
      </muni-shared-brief-agency-rating>
    </div>
  `,
  standalone: false,
})
export class RatingsCellComponent implements ICellRendererAngularComp {
  public params: any;

  public agencies = RATING_AGENCIES;

  public isUnderlyingViewOn$: Observable<boolean> = this.preferencesFacade
    .getPreference('defaultCalendarRatingsView')
    .pipe(
      map(
        (calendarRatingsViewPrefs) => calendarRatingsViewPrefs === 'Underlying'
      )
    );

  constructor(private readonly preferencesFacade: PreferencesFacade) {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
